import { Component, OnInit ,ViewChild, AfterViewInit} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;
@Component({
  selector: 'app-a2-reminder-list',
  templateUrl: './a2-reminder-list.component.html',
  styleUrls: ['./a2-reminder-list.component.scss']
})
export class A2ReminderListComponent extends GridBaseCase implements AfterViewInit{
  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate=null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName:string = null;
  searchValue:string = null;//查询内容
  searchPlaceholder:string = null;//搜索框占位符
  isShowSearchInput:boolean = false;//是否显示搜索框
  tel:any;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal
  ) { super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
  }

  ngAfterViewInit(){
    let that = this;
    that.searchPlaceholder = "姓名或手机号";
    let selectItem = that.element.selectItemList.selectItem;
    if(selectItem.length > 0){
      selectItem.forEach(item=>{
        if(item.elementType && item.elementType=="Search") {
          that.searchPlaceholder = "姓名或手机号";
          // that.searchPlaceholder = item.text;
          that.isShowSearchInput = true;
        }
      })
    }
    let searchArr = that.com.GetStorageKey("searchArray") || [];
    if(searchArr.length > 0){
      searchArr.forEach(item=>{
        if(item.pageName == that.pageName){
          that.searchValue = item.searchInput;
        }
      })
    }
  }
  EventLink(event,item){
    const that=this;
    console.log(item);
    localStorage.setItem("information",JSON.stringify(item));
    this.com.setHistoryUrl(false);
    // this.router.navigate([event.url+item.id.value + "&" + this.com.getNowDatetime]);
    this.com.Go(event.url+item.id.value + "&" + this.com.getNowDatetime);
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
     /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    if(e.keyCode == 13 || type=='search'){
      this.LoadData(1);
    }
  }
  LoadData(PageNumber){
    let that = this;
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if(PageName == 'RepurchaseReminder'){
      body.RequestBody = {"Type":1};
    }else if(PageName == 'TransitionReminder'){
      body.RequestBody = {"Type":2};
    }else if(PageName == 'AwakenReminder'){
      body.RequestBody = {"Type":3};
    }else if(PageName == 'BirthdayReminder'){
      body.RequestBody = {"Type":4};
    }else if(PageName == 'NewcustomersReminder'){
      body.RequestBody = {"Type":5};
    }

    if(that.searchValue){
      body.RequestBody["uar_name"] = that.searchValue.trim();
    }
    // if(that.searchValue){
    //   let selectItem = that.element.selectItemList.selectItem;
    //   if(selectItem.length > 0){
    //     selectItem.forEach(item=>{
    //       if(item.elementType && item.elementType=="Search") {
    //         body.RequestBody[item.field] = that.com.LikeSearch(that.searchValue.trim());
    //       }
    //     })
    //   }
    // }
    const _searchObj = {
      pageName:PageName,
      searchInput:that.searchValue,
    };
    that.com.SaveSearchInfo(_searchObj);
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      console.log("1008611");
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          let arrType=[];
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
            if((element.bindingField == 'birthday' || element.bindingField == 'pre_Date') && objfield[element.bindingField].value){
              objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g,"/");
            }
            that.com.CustomerTag(element,objfield,arrType);//获取所有标签
            // if(element.formatter && element.formatter == "type"){
            //   if(objfield[element.bindingField].value&&objfield[element.bindingField].value){
            //     arrType.push(element.text);
            //   }
            //   if(element.bindingField=="typeall")
            //   {
            //    objfield["typeall"] = { "value": arrType, "text": "新客标签"};
            //   }
            // }
          });
          if(objfield["phone"] && objfield["phone"].value){
            objfield["tel"]={};
            objfield["tel"].value=that.com.PhoneNum(objfield["phone"].value);
          }
          if(objfield["name"] && objfield["name"].value){
            objfield["name"].value=that.com.FormatName(objfield["name"].value);
          }
          that.dataArrayList.push(objfield);
          console.log("selectItem",that.element.selectItemList.selectItem);
          console.log("dataArrayList",that.dataArrayList);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }
}
